import { lazy, Suspense } from "react";
import { Navigate, useParams, useRoutes } from "react-router-dom";

import ArticlePage from "./article";
import ContactPage from "./contact";
import ContactCompletePage from "./contact-complete";
import DocsRoutes from "./docs/routes";
import HomePage from "./home";
import LoginPage from "./login";
import LogoutPage from "./logout";
import NotFoundPage from "./not-found";
import ProductPage from "./products";
import SignupPage from "./signup";

const AccountRoutes = lazy(() => import("./account/routes"));
const AdminRoutes = lazy(() => import("./admin/routes"));
const BillingRoutes = lazy(() => import("./billing/routes"));

export default () =>
  useRoutes([
    { path: "/contact/complete", element: <ContactCompletePage/> },
    { path: "/contact", element: <ContactPage/> },
    { path: "/login", element: <LoginPage/> },
    { path: "/logout", element: <LogoutPage/> },
    { path: "/signup", element: <SignupPage/> },
    { path: "/article/:id", element: <WithParameters component={ArticlePage}/> },
    { path: "/products/:type/:id/:action", element: <WithParameters component={ProductPage}/> },
    { path: "/products/:type/:id", element: <WithParameters component={ProductPage}/> },
    { path: "/products/:type", element: <WithParameters component={ProductPage}/> },
    { path: "/account/*", element: <Suspense><AccountRoutes/></Suspense> },
    { path: "/admin/*", element: <Suspense><AdminRoutes/></Suspense> },
    { path: "/billing/*", element: <Suspense><BillingRoutes/></Suspense> },
    { path: "/docs/*", element: <DocsRoutes/> },
    { path: "/not-found", element: <NotFoundPage/> },
    { path: "/terms.html", element: <ArticlePage id="terms"/> },
    { path: "/terms", element: <ArticlePage id="terms"/> },
    { path: "/*", element: <Navigate replace to="/not-found"/> },
    { path: "/", element: <HomePage/> },
  ]);

function WithParameters({ component: Comp }) {
  const parameters = useParams();
  return <Comp {...parameters} />;
}
